import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { Button } from "@/libraries/design/components";
import { checkFeatureFlagGate } from "@/utils/feature-flags/check-feature-flag";
import { featureFlags } from "@/utils/feature-flags/feature-flag-manifest";

import { useAccountCreationContext } from "../../hooks/account-creation-context";

export const Submit = ({ buttonText }: { buttonText?: string }) => {
    const intl = useIntl();

    const { isSubmitting, hasSubmitted, formError, onClickSubmitButton } =
        useAccountCreationContext();

    const visualFeedback = checkFeatureFlagGate(
        featureFlags.signupVisualAlignmentFeedback
    );

    if (buttonText === undefined) {
        buttonText = intl.formatMessage({
            id: "BxpUiSignup.SignupForm.submit",
            defaultMessage: "Sign up"
        });
    }

    return (
        <Button
            css={[buttonCss, visualFeedback && visualFeedbackCss]}
            type="submit"
            isDisabled={isSubmitting || (hasSubmitted && !formError)}
            isLoading={isSubmitting || (hasSubmitted && !formError)}
            onClick={onClickSubmitButton}
        >
            {buttonText}
        </Button>
    );
};

const buttonCss = css({
    fontFamily: "inherit",
    fontSize: 16,
    maxWidth: "auto",
    paddingBlock: 8,
    width: "100%"
});

const visualFeedbackCss = css({
    borderRadius: "6px !important", // remove !important when gate ships and objects are merged
    fontSize: "14px !important" // remove !important when gate ships and objects are merged
});
